import { render, staticRenderFns } from "./ResearchDirectionsBannerTop.vue?vue&type=template&id=1fbf1092&scoped=true"
import script from "./ResearchDirectionsBannerTop.vue?vue&type=script&lang=js"
export * from "./ResearchDirectionsBannerTop.vue?vue&type=script&lang=js"
import style0 from "./ResearchDirectionsBannerTop.vue?vue&type=style&index=0&id=1fbf1092&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbf1092",
  null
  
)

export default component.exports